/**
 * DesktopSidebar
 * 
 * Simplified desktop sidebar - always visible, can be collapsed/expanded.
 * No overlay, no complex state management.
 */

import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Button } from 'react-bootstrap';
import './DesktopSidebar.scss';

export const DesktopSidebar = ({ children, collapsed, onToggle }) => {
  return (
    <aside 
      className={`desktop-sidebar ${collapsed ? 'collapsed' : ''}`}
      id="sidebar-wrapper"
      role="navigation"
      aria-label="Main navigation"
    >
      {children}
      
      {/* Collapse/Expand tab button on right edge */}
      <Button
        variant="link"
        className="desktop-sidebar-collapse-tab"
        onClick={(e) => {
          onToggle();
          e.currentTarget.blur();
        }}
        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        aria-expanded={!collapsed}
        title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
      </Button>
    </aside>
  );
};

